/* ═══════════════════════════════════════════════════════════════
   OrgService — Organization CRUD via EC2 API (cloud, in-memory cache)
   ═══════════════════════════════════════════════════════════════ */

import type { Organization } from '../../shared/types';
import * as cache from './cloudCache';
import type { TableOpts } from './cloudCache';

const orgOpts: TableOpts = {
  jsonFields: ['addresses', 'contacts'],
};

export const OrgService = {
  list: async (): Promise<Organization[]> => cache.list<Organization>('organizations', orgOpts),

  save: async (org: Organization): Promise<Organization> => cache.save('organizations', org, orgOpts),

  delete: async (id: string): Promise<void> => cache.remove('organizations', id),
};
